module.exports = __webpack_public_path__ + "img/014.363cda8c.jpg";